export default {
  defaultStageData: {},
  changeStageId: 0
}
